import { createBrowserHistory } from "history";

const history = createBrowserHistory({ forceRefresh: false });
export default history;
